var map,
  district,
  polygons = [],
  customClass='',
  lng="",
  lat="",
  citycode;
// var document.getElementById("city") = document.getElementById("city");
// var document.getElementById("district") = document.getElementById("district");
function mm(c,setstatus,setad1) {
  customClass=c;
  map = new AMap.Map("container", {
    resizeEnable: true
  });
  AMap.plugin('AMap.Geolocation', function() {  
    var geolocation = new AMap.Geolocation({
        enableHighAccuracy: true,//是否使用高精度定位，默认:true
        timeout: 30000,          //超过10秒后停止定位，默认：5s
        buttonPosition:'RB',    //定位按钮的停靠位置
        buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
        zoomToAccuracy: true,   //定位成功后是否自动调整地图视野到定位点

    });
    map.addControl(geolocation);
    geolocation.getCurrentPosition(function(status,result){
        if(status=='complete'){
          lat=result.position.lat
          lng=result.position.lng
          //行政区划查询
          var opts = {
            subdistrict: 1, //返回下一级行政区
            showbiz: false //最后一级返回街道信息
          };
          district = new AMap.DistrictSearch(opts); //注意：需要使用插件同步下发功能才能这样直接使用
          if(setstatus){
            setad(setad1)
          } else{
            $.ajax({
              url:"https://restapi.amap.com/v3/geocode/regeo?key=87afac9139f5f9b1e21d361fa9849b6a&location=" +
              lng +
              "," +
              lat +
              "&radius=1000&extensions=all&batch=false&roadlevel=0",
              async:false,
              success:function(data){
                district.search("中国", function(status, result) {
                  if (status == "complete") {
                    getData(result.districtList[0],"province");
                    $("."+customClass+" #province")
                      .find(
                        "option:contains(" +
                          data.regeocode.addressComponent.province +
                          ")"
                      )
                      .attr("selected", true);
                    district.search(data.regeocode.addressComponent.province, function(
                      status,
                      result
                    ) {
                      if (status === "complete") {
                        console.log(result.districtList[0]);
                        getData(result.districtList[0], "city");
                        $("."+customClass+" #city")
                          .find(
                            "option:contains(" +
                              data.regeocode.addressComponent.city +
                              ")"
                          )
                          .attr("selected", true);
                        district.search(data.regeocode.addressComponent.city, function(
                          status,
                          result
                        ) {
                          if (status === "complete") {
                            getData(result.districtList[0], "district");
                            $("."+customClass+" #district")
                              .find(
                                "option:contains(" +
                                  data.regeocode.addressComponent.district +
                                  ")"
                              )
                              .attr("selected", true);
                          }
                        });
                      }
                    });
                  }
                });
              }
            })
          }
        }else{
        }
    });
  });
  
}
function setad(data) {
  //行政区划查询
  var opts = {
    subdistrict: 1, //返回下一级行政区
    showbiz: false //最后一级返回街道信息
  };
  district = new AMap.DistrictSearch(opts); //注意：需要使用插件同步下发功能才能这样直接使用
  district.search("中国", function(status, result) {
    if (status == "complete") {
      getData(result.districtList[0],"province");
      $("."+customClass+" #province")
        .find("option:contains(" + data.province + ")")
        .attr("selected", true);
      district.search(data.province, function(status, result) {
        if (status === "complete") {
          getData(result.districtList[0], "city");
          $("."+customClass+" #city")
            .find("option:contains(" + data.city + ")")
            .attr("selected", true);
          district.search(data.city, function(status, result) {
            if (status === "complete") {
              getData(result.districtList[0], "district");
              $("."+customClass+" #district")
                .find("option:contains(" + data.district + ")")
                .attr("selected", true);
            }
          });
        }
      });
    }
  });
}
function getData(data, level) {
  var bounds = data.boundaries;
  if (bounds) {
    for (var i = 0, l = bounds.length; i < l; i++) {
      var polygon = new AMap.Polygon({
        map: map,
        strokeWeight: 1,
        strokeColor: "#0091ea",
        fillColor: "#80d8ff",
        fillOpacity: 0.2,
        path: bounds[i]
      });
      polygons.push(polygon);
    }
    map.setFitView(); //地图自适应
  }

  //清空下一级别的下拉列表
  if (level === "province") {
    document.getElementById("city").innerHTML = "";
    document.getElementById("district").innerHTML = "";
    // areaSelect.innerHTML = "";
  } else if (level === "city") {
    document.getElementById("district").innerHTML = "";
    // areaSelect.innerHTML = "";
  } else if (level === "district") {
    // areaSelect.innerHTML = "";
  }

  var subList = data.districtList;
  if (subList && subList[0].level != "street") {
    var contentSub;
    var curlevel = subList[0].level;
    console.log(99999,document.querySelector("."+customClass+" #" + curlevel))
    document.querySelector("."+customClass+" #" + curlevel).innerHTML=''
    var curList=document.querySelector("."+customClass+" #" + curlevel);
    // curList.add(contentSub);
    for (var i = 0, l = subList.length; i < l; i++) {
      var name = subList[i].name;
      var levelSub = subList[i].level;
      var cityCode = subList[i].citycode;
      contentSub = new Option(name);
      contentSub.setAttribute("value", levelSub);
      contentSub.center = subList[i].center;
      contentSub.adcode = subList[i].adcode;
      curList.add(contentSub);
    }
  }
  // if(subList && subList[0].level == "city"){
  //   var data=document.querySelector("."+customClass+" #city")
  //   console.log(78787878,data)
  //   search(data)
  // }
}
function search(obj) {
  //清除地图上所有覆盖物
  for (var i = 0, l = polygons.length; i < l; i++) {
    polygons[i].setMap(null);
  }
  var option = obj[obj.options.selectedIndex];
  console.log(777777,option)

  var keyword = option.text; //关键字
  var adcode = option.adcode;
  district.setLevel(option.value); //行政区级别
  district.setExtensions("all");
  //行政区查询
  //按照adcode进行查询可以保证数据返回的唯一性
  district.search(adcode, function(status, result) {
    if (status === "complete") {
      getData(result.districtList[0], obj.id);
    }
  });
}
function setCenter(obj) {
  map.setCenter(obj[obj.options.selectedIndex].center);
}
export { mm, search, setCenter, setad };



// WEBPACK FOOTER //
// ./src/packages/addlist/map.js